import { defineStore } from 'pinia';

export const useLocalStorageStore = defineStore('localStorage', {
  state: () => ({
    // 存储 localStorage 中的所有键值对（响应式）
    items: {} as Record<string, string | null>,
  }),

  actions: {
    // 初始化：从 localStorage 加载所有键值对
    init() {
      // 遍历 localStorage 所有 key，同步到 state
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key) {
          const value = localStorage.getItem(key);
          // 仅在值不同时才更新（避免初始化时不必要的赋值）
          if (this.items[key] !== value) {
            this.items[key] = value;
          }
        }
      }

      // 监听 localStorage 变化（跨标签页/窗口）
      window.addEventListener('storage', (e) => {
        if (e.key) {
          // 仅在值不同时才更新
          if (this.items[e.key] !== e.newValue) {
            this.items[e.key] = e.newValue;
          }
        }
      });
    },

    // 手动更新某一键值（仅在值变化时同步）
    setItem(key: string, value: string) {
      // 1. 先检查与 localStorage 中现有值是否相同
      const currentValue = localStorage.getItem(key);
      if (currentValue === value) {
        // 值未变化，不执行任何操作
        return false;
      }

      // 2. 检查与 Pinia 状态中现有值是否相同
      if (this.items[key] === value) {
        // 值未变化，不执行任何操作
        return false;
      }

      // 3. 只有值变化时才更新
      localStorage.setItem(key, value);
      this.items[key] = value;
      return true; // 返回是否实际更新
    },

    // 删除某一键值（仅在存在时操作）
    removeItem(key: string) {
      // 检查 key 是否存在
      const currentValue = localStorage.getItem(key);
      if (currentValue === null && this.items[key] === null) {
        // 本来就不存在，不执行操作
        return false;
      }

      localStorage.removeItem(key);
      this.items[key] = null;
      return true; // 返回是否实际操作
    },

    // 清空所有键值（仅在有数据时操作）
    clear() {
      // 检查是否有数据
      if (localStorage.length === 0 && Object.keys(this.items).length === 0) {
        // 已经是空的，不执行操作
        return false;
      }

      localStorage.clear();
      this.items = {};
      return true; // 返回是否实际操作
    },
  },
});
